/* Core & libraries */
import React from "react";
import { FormattedMessage, useIntl } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import {
  GET_LOCALES_ENDPOINT
} from '../endpoints/endpoints';
import { useNotificationContext } from "../contexts/notificationContext";


/* Components */
/* Styles */

export const useLanguageService = () => {
  const { setNotification } = useNotificationContext();
  const { genericApiFetch } = useGenericApiFetch();

  const getLocales = async () => {
    const response = await  genericApiFetch({
      url: GET_LOCALES_ENDPOINT,
      method: "GET",
      spinner: "getLocalesSpinner"
    })
    if (response.success) {
      return  response.data;
    } else {
      setNotification(
        'error',
        <FormattedMessage id="locale.errorTitle" />,
        <FormattedMessage id="locale.errorText" />,
      );
      return false
    }
  };

  return {
    getLocales,
  };
}
